import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=437d0c86&"
import script from "./ContentLayout.vue?vue&type=script&lang=js&"
export * from "./ContentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437d0c86')) {
      api.createRecord('437d0c86', component.options)
    } else {
      api.reload('437d0c86', component.options)
    }
    module.hot.accept("./ContentLayout.vue?vue&type=template&id=437d0c86&", function () {
      api.rerender('437d0c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/ContentLayout.vue"
export default component.exports